module.exports = __webpack_public_path__ + "img/google_sync_explanation_mobile.05f7d8f6.png";